import { Directive, TemplateRef } from '@angular/core';

import { ISelectController, Select2Item, SelectContext } from '../../../types';

interface ItemContext<Select extends SelectContext> {
  $implicit: ISelectController<Select>;
  hiddenCount: number;
  hiddenItems: Select2Item[];
}

@Directive({
  standalone: true,
  selector: '[rtSelectSelectedItemCounter]',
  exportAs: 'selectedItemDir',
})
export class SelectedItemCounterDirective<Select extends SelectContext> {
  public static ngTemplateContextGuard<Select extends SelectContext>(
    dir: SelectedItemCounterDirective<Select>,
    ctx: unknown,
  ): ctx is ItemContext<Select> {
    return true;
  }

  constructor(public templateRef: TemplateRef<ItemContext<Select>>) {}
}
